<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <!--dashboards tab-->
      <div class="report-tab">
        <ul class="nav nav-pills" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-dashbord" type="button" role="tab" aria-controls="pills-home" aria-selected="true" (click)="toggleTableOrGraph(1)">Dashboard</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-table" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" (click)="toggleTableOrGraph(2)">Report</button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="dashboard-tabs-container">

    <!--Dashboard filter-->
    <div class="dash-header mb-2 dashboard-filter d-flex">

      <div class="filter-wrapper">
        <div class="dropdown" style="width:unset!important;">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">
              {{deptName}}
            </small>
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>
          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width:100%;">
            <ul>
              <li (click)="selectAllDepartments() "><a class="dropdown-item">All Departments</a></li>
              <li *ngFor="let dept of mainDepartmentList" (click)="setFilterNames(dept,2)"><a class="dropdown-item">{{dept.departmentDescr}}</a></li>
            </ul>

          </div>
        </div>
      </div>

      <div class="filter-wrapper date-range" (click)="openCalender()" style="cursor:pointer">
        <div class="dropdown" style="width:unset!important;">
          <div class="report-type d-flex ps-0" data-bs-toggle="dropdown" style="width:18rem">
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false"
                    style="border-radius:8px 0px 0px 8px;  border-right: 1px solid #D4D4D4;background:#F5F5F5;border-left:none ">
              <img src="assets/pos/products/ic_leftArrow.svg" />
            </button>
            <input class="h-100" type="text" name="daterangeInput" daterangepicker #dateRange [options]="options" (selected)="selectedDate($event, daterange)" style="width:19rem;" />
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false" style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #D4D4D4; background: #F5F5F5;border-right:none ">
              <img src="assets/pos/products/ic_rightArrow.svg" />
            </button>
          </div>
        </div>
      </div>

      <div class="create-btn run-report-btn ms-2 c-pt" [class.is-loading]="isLoading" (click)="runReport()">
        <span class="run-spinner" *ngIf="isLoading"></span>
        <img *ngIf="!isLoading" src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        {{ isLoading ? "Running…" : "Run Report" }}
      </div>
    </div>

    <!-- empty state: shown until the report is run -->
    <div class="report-empty-state" *ngIf="!reportHasRun">
      <img src="assets/dashboard/noData.svg" alt="" />
      <h5>Ready when you are</h5>
      <p>Adjust the filters above, then click <strong>Run Report</strong> to generate the production dashboard.</p>
      <div class="create-btn run-report-btn c-pt" (click)="runReport()">
        <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        Run Report
      </div>
    </div>

    <div class="dashboard-container mt-3" [hidden]="!reportHasRun">
      <div class="tab-content" id="pills-tabContent" style="position:relative">
        <!-- Dashboard-->
        <div class="tab-pane fade show active" id="pills-dashbord" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
          <div class="chart-wrapper">
            <div class="stat-text-wrapper">
              <div class="content">
                <div class="text-content">
                  <p>Total Items Entry</p>
                  <h1>{{ totalQty > 0 ? (totalQty|number) : 0 }}</h1>
                </div>
                <img src="assets/dashboard/ic_totalEntry.svg" />
              </div>

              <div class="content">

                <div class="text-content">
                  <p>Total Value of Items</p>
                  <h1>{{(totalPrice  > 0 ? totalPrice : 0) | currency}}</h1>
                </div>
                <img src="assets/dashboard/ic_totalValue.svg" />
              </div>

              <div class="content">
                <div class="text-content">
                  <p>Category</p>
                  <h1>{{(totalCatg > 0 ? totalCatg :0)}}</h1>
                </div>
                <img src="assets/dashboard/ic_categories.svg" />
              </div>

            </div>


            <div class="mt-3 category">
              <div class="cahrt-text d-flex justify-content-between ">
                <h2 class="chart-title">Total Items Entry per Department and Category  </h2>
                <p class="chart-title"><span style="font-weight:400">Total</span> :  {{deptQty|number}}</p>
              </div>
              <div class="mt-3" *ngIf="categoryData">
                  <div>
                  <canvas id="category" #categoryCanvas></canvas>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center justify-content-center " *ngIf="!categoryData" style="height:100%;">
                <img src="../../../assets/dashboard/noDataFound.svg" style="height:130px" />
                <h5 style="color:#999999">No Data Found</h5>
              </div>
            </div>

            <div class="mt-3 category">
              <div class="cahrt-text d-flex justify-content-between ">
                <h2 class="chart-title">Productivity at Employee level </h2>
                <p class="chart-title"><span style="font-weight:400">Total</span> : {{empQty|number}}</p>
              </div>
              <div class=" employee mt-3" *ngIf="employeeData">
                  <div>
                  <canvas id="employee" #employeeCanvas></canvas>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center justify-content-center " *ngIf="!employeeData" style="height:100%;">
                <img src="../../../assets/dashboard/noDataFound.svg" style="height:130px" />
                <h5 style="color:#999999">No Data Found</h5>
              </div>
            </div>

            <div class="mt-3 category">
              <div class="cahrt-text d-flex justify-content-between ">
                <h2 class="chart-title">Productivity at Brand level </h2>
                <p class="chart-title"> <span style="font-weight:400">Total</span> : {{brandQty|number}}</p>
              </div>
              <div class=" brand mt-3" *ngIf="brandData">
                  <div>
                  <canvas id="brand" #brandCanvas></canvas>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center justify-content-center " *ngIf="!brandData" style="height:100%;">
                <img src="../../../assets/dashboard/noDataFound.svg" style="height:130px" />
                <h5 style="color:#999999">No Data Found</h5>
              </div>
            </div>

            <div class="container-fluid split-chart">
              <div class="print-cahrt wd-8">
                <div class="mt-3 category">
                  <div class="cahrt-text d-flex justify-content-between ">
                    <h2 class="chart-title">Print Format</h2>
                    <p class="chart-title"><span style="font-weight:400">Total</span> : {{formatQty|number}}</p>
                  </div>
                  <div class="brand mt-3" *ngIf="printData">

                    <div>
                      <canvas id="print" #printCanvas></canvas>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-items-center justify-content-center " *ngIf="!printData" style="height:100%;">
                    <img src="../../../assets/dashboard/noDataFound.svg" style="height:130px" />
                    <h5 style="color:#999999">No Data Found</h5>
                  </div>
                </div>
              </div>

              <div class="special-price-chart wd-4">
                <div class="print-cahrt">
                  <div class="mt-3 category">
                    <div class="cahrt-text d-flex justify-content-between ">
                      <h2 class="chart-title">Special Price Items </h2>
                      <p class="chart-title"><span style="font-weight:400">Total</span> :  {{specialPriceQty|number}}</p>
                    </div>
                    <div class="brand mt-3" *ngIf="specialPriceData">
                      <div>
                        <canvas id="price" #priceCanvas></canvas>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-items-center justify-content-center" *ngIf="!specialPriceData" style="height:100%;">
                      <img src="../../../assets/dashboard/noDataFound.svg" style="height:130px" />
                      <h5 style="color:#999999">No Data Found</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
        <!-- Table-->
        <div class="tab-pane fade" id="pills-table" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">

          <section class="table-view mt-3">
            <div class="table-container" *ngIf="dashboardTabledata?.length; else noReportRows">
              <table class="table table-condensed parent-table ">
                <thead class="main-head sticky-top">
                  <tr>
                    <th class="dept-col">Departments </th>
                    <th [ngClass]="{'text-end': true, 'last-td-padding': last}" [ngStyle]="{'width': last ? '19%' : '9%'}"
                        *ngFor="let store of StoreNames;let last = last">{{store}} </th>
                    <th class="text-end pe-5 total-col">Total</th>
                  </tr>
                </thead>
                <tbody *ngFor="let dept of dashboardTabledata; let i = index" id="mainParent">
                  <tr class="accordion-toggle department-row" data-bs-toggle="collapse" [attr.data-bs-target]="'#userDetails' + i">

                    <td class="d-flex departmentName dept-col" data-bs-toggle="collapse" [attr.data-bs-target]="'#userDetails' + i">
                      <button class="accordian-btn me-2">
                        <img src="assets/dashboard/ic_activation.svg" />
                      </button> <span>{{dept.department}}</span>
                    </td>
                    <td *ngFor="let store of StoreNames;let last = last;let i = index"
                        [ngClass]="{'text-end overflow-auto': true, 'last-td-padding': last}">
                      {{(getDeptUserWiseQty(dept,store)|number)}}
                    </td>
                    <td class="text-end pe-5 total-col">{{(calculateRowTotal(dashboardTabledata[i].qty)|number)}}</td>
                  </tr>
                  <tr>
                    <td colspan="12" class="hiddenRow px-0 py-0">
                      <div class="accordian-body collapse" [attr.id]="'userDetails' + i" data-bs-parent="#mainParent">
                        <table class="table mb-0" *ngFor="let ctg of dashboardTabledata[i].categories;let j=index">
                          <thead>
                            <tr class="ctg-row">
                              <td class="ps-5 dept-col">
                                {{ctg.cname}}
                              </td>
                              <td [ngClass]="{'text-end': true, 'last-td-padding': last}" [ngStyle]="{'width': last ? '19%' : '9%'}"
                                  *ngFor="let store of StoreNames;let last = last">
                                {{(getDeptUserWiseQty(ctg,store)|number)}}
                              </td>
                              <td class="text-end pe-5 total-col">{{(calculateRowTotal(dashboardTabledata[i].categories[j].qty)|number)}}</td>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody class="bottom-total">
                  <tr class="total-row">
                    <td class="text-start ps-5 dept-col">Total</td>
                    <td *ngFor="let store of StoreNames;let last = last;let i = index"
                        [ngClass]="{'text-end overflow-auto': true, 'last-td-padding': last}">
                      {{(calculateColumnTotal(store)|number)}}
                    </td>
                    <td class="pe-5 total-col">
                      {{tableDataTotalQty|number}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noReportRows>
              <div class="report-empty-state report-empty-state--inline">
                <img src="assets/dashboard/noData.svg" alt="" />
                <h5>No data found</h5>
                <p>
                  No production activity matches the selected filters and date
                  range. Adjust them and run the report again.
                </p>
              </div>
            </ng-template>
          </section>
        </div>

        <!--loader-->
        <div class="overlay" *ngIf="isLoading">
          <div class="loader"></div>
        </div>
      </div>

    </div>

  </div>


</div>


